<template>
  <div>
    <Card>
      <template #title>Grupos de Segurança</template>
      <template #content>
        <DataTable
          class="p-datatable-sm"
          :paginator="true"
          :rows="5"
          stripedRows
          :loading="loading"
          :value="grupoSegurancaList"
          dataKey="id"
          :filters.sync="filtros"
          :globalFilterFields="['nome']"
          filterDisplay="menu"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} vínculos"
          responsiveLayout="scroll">
          <template #empty> Nenhum grupo de segurança encontrado. </template>
          <template #loading> Carregando. Por favor aguarde. </template>
          <template #header>
            <span class="mt-2 mr-2 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filtros['global'].value"
                placeholder="Pesquisar"
                style="width: 100%" />
            </span>
            <Button
              icon="pi pi-filter-slash"
              label="Limpar"
              class="mt-2 mr-2 p-button-outlined"
              @click="limparFiltro" />
            <Button
              label="Novo Grupo"
              icon="pi pi-plus"
              class="mt-2 mr-2 p-button-submit float-right"
              @click="showFormDialog()" />
          </template>
          <Column field="nome" header="Nome"></Column>
          <Column header="Ações">
            <template #body="{ data }">
              <Button
                v-tooltip.left="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning mr-2"
                @click="showFormDialog(data)" />
              <Button
                v-tooltip.left="'Remover'"
                class="p-button-danger p-button-rounded mt-2"
                icon="pi pi-trash"
                @click="removerGrupo(data)" />
            </template>
          </Column>
        </DataTable>
      </template>
    </Card>
    <GrupoSegurancaFormDialog
      :visible.sync="showDialog"
      :update="update"
      :propsgruposeguranca="grupoSeguranca" />
  </div>
</template>
<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api/'
import { watch } from 'vue-demi'
import GrupoSegurancaFormDialog from './GrupoSegurancaFormDialog.vue'
import GrupoSegurancaService from '@/service/GrupoSegurancaService.js'

export default {
  components: {
    GrupoSegurancaFormDialog,
  },
  data() {
    return {
      loading: false,
      grupoSegurancaList: [],
      grupoSeguranca: {},
      filtros: {},
      showDialog: false,
      update: false,
    }
  },

  created() {
    this.grupoSegurancaService = new GrupoSegurancaService(this.$http)
    this.initFiltros()
    this.loading = true
    watch(
      () => this.showDialog,
      () => {
        if (!this.showDialog) {
          this.carregarDados()
        }
      },
    )
  },

  mounted() {
    this.carregarDados()
  },

  methods: {
    limparFiltro() {
      this.initFiltros()
    },

    initFiltros() {
      this.filtros = {
        global: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.CONTAINS },
            { value: null, matchMode: FilterMatchMode.EQUALS },
          ],
        },
      }
    },

    carregarDados() {
      this.grupoSegurancaService
        .getAll()
        .then((res) => {
          this.grupoSegurancaList = res
          this.loading = false
        })
        .catch((err) => {
          this.exibirToastError(err)
        })
    },

    showFormDialog(data) {
      if (data) {
        this.grupoSeguranca = data
        this.update = true
      } else {
        this.grupoSeguranca = {}
        this.update = false
      }
      this.showDialog = true
    },

    removerGrupo(data) {
      this.grupoSegurancaService
        .delete(data.id)
        .then(() => {
          this.carregarDados()
          this.exibirToastSuccess('Grupo Segurança removido com sucesso!')
        })
        .catch((err) => {
          this.exibirToastError(err)
        })
    },

    exibirToastSuccess(message) {
      this.$toast.add({
        severity: 'success',
        summary: message,
        life: 10000,
      })
    },

    exibirToastError(err) {
      this.$toast.add({
        severity: 'error',
        summary: err.response,
        life: 10000,
      })
    },
  },
}
</script>
<style></style>
